// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e92c04cb","239":"490db064","453":"9da80e27","732":"42fa4315"}[chunkId] + ".chunk.js";
};